export const cloudPbxPlans = [
  {
    id: "4",
    title: "به ازای هر کاربر در ماه",
    price: "126",
    label: "بسته پایه",
    class: "brown",
    options: [
        { title: "اپلیکیشن اختصاصی", },
        { title: "پنل مدیریتی پیشرفته" },
        { title: "تلفن گویا چند سطحی" },
        { title: "صف تماس با استراتژی‌های مختلف" },
        { title: "گزارش تماس‌ها" },
        { title: "پیام‌رسانی سازمانی" },
        { title: "نظرسنجی تماس و گزارش عملکرد" },
        { title: "اتصال به IP-Phone" },
    ],
    // off: 20,
  },
  {
    id: "3",
    title: "به ازای هر کاربر در ماه",
    price: "122",
    label: "بسته عملیاتی",
    class: "silver",
    options: [
        { title: "همه ویژگی‌های بسته پایه+" },
        { title: "مانیتورینگ زنده کاربران" },
        { title: "کنترل، نجوا و ورود به مکالمات" },
        { title: "گزارش تماس‌های از دست رفته" },
        { title: "ثبت اطلاعات و مدیریت مخاطبان" },
        { title: "مدیریت نقش، سطوح و حقوق" },
        { title: "تعریف دپارتمان" },
        { title: "پاپ آپ تماس و کلیک تو کال" },
    ],
    // off: 20,
  },
  {
    id: "2",
    title: "به ازای هر کاربر در ماه",
    price: "120",
    label: "بسته یکپارچه",
    class: "yellow",
    options: [
        { title: "همه ویژگی‌های بسته عملیاتی+" },
        { title: "تاریخچه تعاملات و پروفایل ۳۶۰ درجه" },
        { title: "پنل پیامکی" },
        { title: "چت آنلاین سایت" },
        { title: "اتصال به واتس‌اپ" },
        { title: "مدیریت وظایف" },
        { title: "مدیریت تیکت‌ها" },
        { title: "اتوماسیون گردش کار" }
    ],
    // off: 25,
  },
  {
    id: "1",
    title: "به ازای هر کاربر در ماه",
    price: "108",
    label: "بسته فراگیر",
    class: "green",
    options: [
        { title: "همه ویژگی‌های بسته یکپارچه+" },
        { title: "کلیه قابلیت‌های مرکز تماس" },
        { title: "کلیه قابلیت‌های CRM" },
        { title: "مدیریت سرنخ‌ها" },
        { title: "مدیریت فرصت فروش" },
        { title: "مدیریت محصولات" },
        { title: "انبارداری" },
        { title: "فاکتور و پیش فاکتور" }
    ],
    // off: 30,
  },
];

export const metamaPlans = [
  {
    id: "3",
    title: "سالیانه",
    price: "13740000",
    setupFee: "0",
    label: "بسته برنزی",
    class: "brown",
    options: [
      { id: "0", title: "پرداخت سالانه" },
      { id: "1", title: " 5کاربر" },
      { id: "2", title: "1 گیگ فضای ذخیره‌سازی ابری" },
      { id: "3", title: "پشتیبانی 24/7" },
      { id: "4", title: "اپلیکیشن اختصاصی" },
      { id: "5", title: "داشبورد مدیریتی" },
    ],
    type: "metama",
    // off: "10",
  },
  {
    id: "4",
    title: "سالیانه",
    price: "19020000",
    setupFee: "0",
    label: "بسته نقره‌ای",
    class: "brown",
    options: [
      { id: "0", title: "پرداخت سالانه" },
      { id: "1", title: " 10کاربر" },
      { id: "2", title: "2 گیگ فضای ذخیره‌سازی ابری" },
      { id: "3", title: "پشتیبانی 24/7" },
      { id: "4", title: "اپلیکیشن اختصاصی" },
      { id: "5", title: "داشبورد مدیریتی" },
    ],
    type: "metama",
    // off: "10",
  },
  {
    id: "2",
    title: "سالیانه",
    price: "34620000",
    setupFee: "0",
    label: "بسته طلایی",
    class: "yellow",
    options: [
      { id: "0", title: "پرداخت سالانه" },
      { id: "1", title: "20 کاربر " },
      { id: "2", title: "5 گیگ فضای ذخیره‌سازی ابری" },
      { id: "3", title: "پشتیبانی 24/7" },
      { id: "4", title: "اپلیکیشن اختصاصی" },
      { id: "5", title: "داشبورد مدیریتی" },
    ],
    type: "metama",
    // off: "30",
  },
  {
    id: "1",
    title: "سالیانه",
    price: "48540000",
    setupFee: "0",
    label: "بسته اپال",
    class: "green",
    options: [
      { id: "0", title: "پرداخت سالانه" },
      { id: "1", title: "30کاربر " },
      { id: "2", title: "10 گیگ فضای ذخیره‌سازی ابری" },
      { id: "3", title: "پشتیبانی 24/7" },
      { id: "4", title: "اپلیکیشن اختصاصی" },
      { id: "5", title: "داشبورد مدیریتی" },
    ],
    type: "metama",
    // off: "40",
  },
];

export const roundPlans = [
  {
    id: "4",
    title: "به ازای هر کاربر در ماه",
    price: "210",
    label: "بسته پایه",
    class: "brown",
    options: [
        { title: "اپلیکیشن اختصاصی", },
        { title: "پنل مدیریتی پیشرفته" },
        { title: "تلفن گویا چند سطحی" },
        { title: "صف تماس با استراتژی‌های مختلف" },
        { title: "گزارش تماس‌ها" },
        { title: "پیام‌رسانی سازمانی" },
        { title: "نظرسنجی تماس و گزارش عملکرد" },
        { title: "اتصال به IP-Phone" },
    ],
    // off: "20",
  },
  {
    id: "3",
    title: "به ازای هر کاربر در ماه",
    price: "174",
    label: "بسته عملیاتی",
    class: "silver",
    options: [
        { title: "همه ویژگی‌های بسته پایه+" },
        { title: "مانیتورینگ زنده کاربران" },
        { title: "کنترل، نجوا و ورود به مکالمات" },
        { title: "گزارش تماس‌های از دست رفته" },
        { title: "ثبت اطلاعات و مدیریت مخاطبان" },
        { title: "مدیریت نقش، سطوح و حقوق" },
        { title: "تعریف دپارتمان" },
        { title: "پاپ آپ تماس و کلیک تو کال" },
    ],
    // off: "20",
  },
  {
    id: "2",
    title: "به ازای هر کاربر در ماه",
    price: "162",
    label: "بسته یکپارچه",
    class: "yellow",
    options: [
        { title: "همه ویژگی‌های بسته عملیاتی+" },
        { title: "تاریخچه تعاملات و پروفایل ۳۶۰ درجه" },
        { title: "پنل پیامکی" },
        { title: "چت آنلاین سایت" },
        { title: "اتصال به واتس‌اپ" },
        { title: "مدیریت وظایف" },
        { title: "مدیریت تیکت‌ها" },
        { title: "اتوماسیون گردش کار" }
    ],
    // off: "25",
  },
  {
    id: "1",
    title: "به ازای هر کاربر در ماه",
    price: "150",
    label: "بسته فراگیر",
    class: "green",
    options: [
        { title: "همه ویژگی‌های بسته یکپارچه+" },
        { title: "کلیه قابلیت‌های مرکز تماس" },
        { title: "کلیه قابلیت‌های CRM" },
        { title: "مدیریت سرنخ‌ها" },
        { title: "مدیریت فرصت فروش" },
        { title: "مدیریت محصولات" },
        { title: "انبارداری" },
        { title: "فاکتور و پیش فاکتور" }
    ],
    // off: "30",
  },
];

export const faxPlans = [
  {
    title: "به ازای هر کاربر در ماه",
    price: "476",
    label: "بدون مرکز تلفن ابری نواتل",
    class: "brown",
    options: [
      { id: "0", title: "پرداخت سالانه" },
      { id: "1", title: "2 کانال همزمانی رایگان" },
      { id: "2", title: "ارسال و دریافت فکس به تعداد نامحدود" },
      { id: "3", title: "آرشیو فکس‌ها" },
      { id: "4", title: "دریافت فکس از طریق اپلیکیشن و ایمیل" },
    ],
  },
  {
    title: "به ازای هر کاربر در ماه",
    price: "418",
    label: "با مرکز تلفن ابری نواتل",
    class: "silver",
    options: [
      { id: "0", title: "پرداخت سالانه" },
      { id: "1", title: "2 کانال همزمانی رایگان" },
      { id: "2", title: "ارسال و دریافت فکس به تعداد نامحدود" },
      { id: "3", title: "آرشیو فکس‌ها" },
      { id: "4", title: "دریافت فکس از طریق اپلیکیشن و ایمیل" },
    ],
  },
];

export const crmPlans = [
  {
    id: "4",
    title: "به ازای هر کاربر در ماه",
    price: "144",
    label: "بسته پایه",
    class: "brown",
    options: [
      { title: "پنل مدیریتی پیشرفته" },
      { title: "اپلیکیشن تخصصی" },
      { title: "مدیریت مشتریان" },
      { title: "سرنخ‌های فروش" },
      { title: "مدیریت فرصت‌های فروش" },
      { title: "وظایف و پیگیری‌ها" },
      { title: "محصولات و انبار" },
      { title: "صدور فاکتور و پیش فاکتور" },
    ],
    // off: 30,
  },
  {
    id: "3",
    title: "به ازای هر کاربر در ماه",
    price: "114",
    label: "بسته عملیاتی",
    class: "silver",
    options: [
      { title: "همه ویژگی‌های بسته پایه+" },
      { title: "مدیریت دپارتمان و اعضای تیم" },
      { title: "مدیریت نقش، سطوح و حقوق" },
      { title: "تیکتینگ" },
      { title: "گزارش گیری پیشرفته تیکت‌ها" },
      { title: "قابلیت اتصال به مرکز تلفن نواتل" },
      { title: "کلیک‌تو‌کال با اتصال به مرکز تلفن" },
      { title: "پاپ‌آپ تماس با اتصال به مرکز تلفن" },
    ],
    // off: 30,
  },
  {
    id: "2",
    title: "به ازای هر کاربر در ماه",
    price: "108",
    label: "بسته یکپارچه",
    class: "yellow",
    options: [
        { title: "همه ویژگی‌های بسته عملیاتی+" },
        { title: "تاریخچه تعاملات و پروفایل ۳۶۰ درجه" },
        { title: "اتوماسیون گردش‌کار" },
        { title: "پنل پیامکی با خط اختصاصی" },
        { title: "وب‌سرویس پنل پیامکی" },
        { title: "چت آنلاین یکپارچه" },
        { title: "اتصال به واتس‌اپ" },
        { title: "یکپارچه‌سازی کانال‌های ارتباطی" }
    ],
    // off: 30,
  },
  {
    id: "1",
    title: "به ازای هر کاربر در ماه",
    price: "90",
    label: "بسته فراگیر",
    class: "green",
    options: [
      { title: "همه ویژگی‌های بسته یکپارچه+" },
      { title: "کلیه قابلیت‌های مرکز تماس" },
      { title: "تلفن گویای چند سطحی" },
      { title: "صف تماس با استراتژی‌های مختلف" },
      { title: "مانیتورینگ زنده کاربران" },
      { title: "نجوا، ورود و کنترل به مکالمات" },
      { title: "گزارش‌های پیشرفته تماس" },
      { title: "اتصال به آی‌پی‌فون" }
    ],
    // off: 30,
  },
];

export const smsPlans = [
  {
    id: "4",
    title: "به ازای هر کاربر در ماه",
    price: "131",
    label: "بسته پایه",
    class: "brown",
    options: [
      { id: "0", title: "پرداخت سالانه", isExists: true },
      { id: "1", title: "ارسال تکی،گروهی و انبوه", isExists: true },
      { id: "2", title: "گزارش ارسال و دریافت", isExists: true },
      { id: "3", title: "ایجاد گروه و لیست مخاطبین", isExists: true },
      { id: "4", title: "ساخت پیام‌های پیش فرض", isExists: true },
      { id: "5", title: "امکان ارسال پیامک از طریق اپلیکیشن اختصاصی", isExists: true },
      { id: "6", title: "امکان ارسال پیامک از طریق سی آر ام", isExists: true },
      { id: "7", title: "امکان تبدیل ارسال کننده پیامک‌ها به سرنخ", isExists: true },
      { id: "8", title: "ارسال زماندار ", isExists: true },
      { id: "9", title: "ارسال پارامتریک و متناظر", isExists: false },
      { id: "10", title: "امکان ارسال کد تایید (OTP)", isExists: false },
    ],
  },
  {
    id: "3",
    title: "به ازای هر کاربر در ماه",
    price: "179",
    label: "بسته پیشرفته",
    class: "silver",
    options: [
      { id: "0", title: "پرداخت سالانه", isExists: true },
      { id: "1", title: "ارسال تکی،گروهی و انبوه", isExists: true },
      { id: "2", title: "گزارش ارسال و دریافت", isExists: true },
      { id: "3", title: "ایجاد گروه و لیست مخاطبین", isExists: true },
      { id: "4", title: "ساخت پیام‌های پیش فرض", isExists: true },
      { id: "5", title: "امکان ارسال پیامک از طریق اپلیکیشن اختصاصی", isExists: true },
      { id: "6", title: "امکان ارسال پیامک از طریق سی آر ام", isExists: true },
      { id: "7", title: "امکان تبدیل ارسال کننده پیامک‌ها به سرنخ", isExists: true },
      { id: "8", title: "ارسال زماندار ", isExists: true },
      { id: "9", title: "ارسال پارامتریک و متناظر", isExists: true },
      { id: "10", title: "امکان ارسال کد تایید (OTP)", isExists: false },
    ],
  },
  {
    id: "2",
    title: "به ازای هر کاربر در ماه",
    price: "227",
    label: "بسته استراتژیک",
    class: "yellow",
    options: [
      { id: "0", title: "پرداخت سالانه", isExists: true },
      { id: "1", title: "ارسال تکی،گروهی و انبوه", isExists: true },
      { id: "2", title: "گزارش ارسال و دریافت", isExists: true },
      { id: "3", title: "ایجاد گروه و لیست مخاطبین", isExists: true },
      { id: "4", title: "ساخت پیام‌های پیش فرض", isExists: true },
      { id: "5", title: "امکان ارسال پیامک از طریق اپلیکیشن اختصاصی", isExists: true },
      { id: "6", title: "امکان ارسال پیامک از طریق سی آر ام", isExists: true },
      { id: "7", title: "امکان تبدیل ارسال کننده پیامک‌ها به سرنخ", isExists: true },
      { id: "8", title: "ارسال زماندار ", isExists: true },
      { id: "9", title: "ارسال پارامتریک و متناظر", isExists: true },
      { id: "10", title: "امکان ارسال کد تایید (OTP)", isExists: true },
    ],
  },
];

export const cloudPbxCompareData = {
  id: 1,
  title: "ویژگی‌های بسته‌های مرکز تماس ابری",
  subTitle: "ویژگی های اصلی",
  packagenames: {
    boronz: "بسته کریپتون",
    noghre: "بسته کادمیوم",
    talaei: "بسته بیسموت",
    opal: "بسته تنگستن",
  },
  listPack: [
    {
      id: 1,
      title: " فضای ابری (گیگ)",
      boronz: "5",
      noghre: "10",
      talaei: "15",
      opal: "20",
    },
    {
      id: 1,
      title: "تعداد کاربر",
      boronz: "50",
      noghre: "100",
      talaei: "150",
      opal: "200",
    },
    // {
    //   id: 2,
    //   title: "همزمانی تماس (بوق آزاد)",
    //   boronz: "5",
    //   noghre: "10",
    //   talaei: "15",
    //   opal: "20",
    // },
  ],
  options: [
    {
      id: 3,
      title: "سافت فون اختصاصی",
      // mobile_title: "چت سازمانی",
      packages: {
        boronz: true,
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 4,
      title: "داشبورد مدیریتی",
      packages: {
        boronz: true,
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 5,
      title: "پیامگیر صوتی",
      packages: {
        boronz: true,
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 6,
      title: "نظرسنجی",

      packages: {
        boronz: true,
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 7,
      title: "تیکتینگ",

      packages: {
        boronz: true,
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 8,
      title: "گزارش پیشرفته",

      packages: {
        boronz: true,
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 9,
      title: "گزارش پراکندگی",

      packages: {
        boronz: true,
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 10,
      title: "تعیین سطوح دسترسی",

      packages: {
        boronz: true,
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 11,
      title: "لیست سیاه و سفید",

      packages: {
        boronz: true,
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 12,
      title: "مانیتورینگ زنده تماس‌ها",

      packages: {
        boronz: true,
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 13,
      title: "کنترل زنده تماس‌ها",

      packages: {
        boronz: true,
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 18,
      title: "نجوا",

      packages: {
        boronz: true,
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 14,
      title: "والبورد",

      packages: {
        boronz: true,
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 16,
      title: "چت آنلاین (وبچت)",

      packages: {
        boronz: true,
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 17,
      title: "قابلیت اتصال به آی پی فون",

      packages: {
        boronz: true,
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 15,
      title: "فکس ابری",

      packages: {
        boronz: true,
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
    {
      id: 19,
      title: "تماس مجدد با آخرین اپراتور",

      packages: {
        boronz: true,
        noghre: true,
        talaei: true,
        opal: true,
      },
    },
  ],
};
